import { GrFacebookOption, GrYoutube, GrInstagram } from 'react-icons/gr';
import { useHistory } from 'react-router-dom';

import LogoSvg from '../../assets/svg/logo-blue.svg';
import VisaSvg from '../../assets/svg/visa.svg';
import MastercardSvg from '../../assets/svg/mastercard.svg';
import PaypalSvg from '../../assets/svg/paypal.svg';
import { useAuth } from '../../hooks/auth';
import { useFilters } from '../../hooks/projectFilters';

import {
  Bottom,
  Brand,
  BrandText,
  Column,
  ColumnTitle,
  Container,
  Copyright,
  ExternalLink,
  Grid,
  Logo,
  NavButton,
  PaymentMethods,
  PaymentMethodSvg,
  SafePaymentText,
  SocialIconsContainer,
} from './styles';

const Footer = () => {
  const history = useHistory();
  const { isLoggedIn, userType } = useAuth();
  const { resetFilters, setPrice, setCurrentPage } = useFilters();

  function goToProjects(priceFilter) {
    resetFilters();
    if (priceFilter) setPrice(priceFilter);
    setCurrentPage(1);
    history.push('/projects');
  }

  return (
    <Container>
      <Grid>
        <Brand>
          <Logo src={LogoSvg} alt="Portal Due It" />
          <BrandText>
            O lugar onde a comunidade Due descobre o que criar, aprende como
            fazer e encontra inspiração para vender.
          </BrandText>
          <SocialIconsContainer>
            <a
              href="https://www.facebook.com/duelaser"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <GrFacebookOption size={20} title="Facebook" />
            </a>
            <a
              href="https://www.instagram.com/duelaser"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <GrInstagram size={19} title="Instagram" />
            </a>
            <a
              href="https://www.youtube.com/duelaser"
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
            >
              <GrYoutube size={21} title="YouTube" />
            </a>
          </SocialIconsContainer>
        </Brand>

        <Column>
          <ColumnTitle>Explorar</ColumnTitle>
          <NavButton type="button" onClick={() => goToProjects()}>
            Todos os projetos
          </NavButton>
          <NavButton type="button" onClick={() => goToProjects('free')}>
            Gratuitos
          </NavButton>
          {isLoggedIn && (
            <NavButton type="button" onClick={() => history.push('/favorites')}>
              Favoritos
            </NavButton>
          )}
        </Column>

        <Column>
          <ColumnTitle>Comunidade</ColumnTitle>
          {isLoggedIn ? (
            <NavButton
              type="button"
              onClick={() => history.push(`/${userType}/profile`)}
            >
              Minha conta
            </NavButton>
          ) : (
            <NavButton type="button" onClick={() => history.push('/login')}>
              Minha conta
            </NavButton>
          )}
          <NavButton
            type="button"
            onClick={() => history.push('/become-designer')}
          >
            Vender projetos
          </NavButton>
        </Column>

        <Column>
          <ColumnTitle>Ecossistema Due</ColumnTitle>
          <ExternalLink
            href="https://loja.duelaser.com/materiais-"
            target="_blank"
            rel="noreferrer"
          >
            Loja Due
          </ExternalLink>
          <ExternalLink
            href="https://loja.duelaser.com/maquinas"
            target="_blank"
            rel="noreferrer"
          >
            Máquinas Due
          </ExternalLink>
        </Column>

        <Column>
          <ColumnTitle>Ajuda</ColumnTitle>
          <ExternalLink
            href="https://duelaser.com/termos/#termos"
            target="_blank"
            rel="noreferrer"
          >
            Termos e Privacidade
          </ExternalLink>
          <ExternalLink
            href="https://www.duelaser.com/contato"
            target="_blank"
            rel="noreferrer"
          >
            Entre em contato
          </ExternalLink>
          <ExternalLink
            href="https://duelaser.com/suporte/"
            target="_blank"
            rel="noreferrer"
          >
            Central de ajuda
          </ExternalLink>
        </Column>
      </Grid>

      <Bottom>
        <Copyright>
          © {new Date().getFullYear()} Due Laser · Todos os direitos reservados
        </Copyright>
        <PaymentMethods>
          <SafePaymentText>Pagamento seguro</SafePaymentText>
          <PaymentMethodSvg src={VisaSvg} alt="Cartão Visa" />
          <PaymentMethodSvg src={MastercardSvg} alt="Cartão Mastercard" />
          <PaymentMethodSvg src={PaypalSvg} alt="Paypal" />
        </PaymentMethods>
      </Bottom>
    </Container>
  );
};

export default Footer;
